/**
 * Franchise single: tabs, maps, location filters, state location lists.
 * Map init lives in locations-map.js (DFDLocationsMap).
 */
(function ($) {
	'use strict';

	var STATE_LIST_HASH = 'franchise-locations-by-state';

	function cfg() {
		return window.dfdFranchiseSingle || {};
	}

	function i18n(key, fallback) {
		var strings = cfg().i18n || {};
		return strings[key] || fallback;
	}

	function escapeHtml(str) {
		if (window.DFDLocationsMap && window.DFDLocationsMap.escapeHtml) {
			return window.DFDLocationsMap.escapeHtml(str);
		}
		return String(str || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	function refreshVisibleMaps(root) {
		root.find('[data-franchise-map]').each(function () {
			var el = this;
			if ($(el).closest('.franchise-panel').length && $(el).closest('.franchise-panel').is('[hidden]')) {
				return;
			}
			if ($(el).closest('[data-locations-pane]').length && $(el).closest('[data-locations-pane]').is('[hidden]')) {
				return;
			}
			if (window.DFDLocationsMap) {
				window.DFDLocationsMap.initMap(el);
				window.DFDLocationsMap.invalidate(el);
			}
		});
	}

	function scrollToEl($el) {
		if (!$el || !$el.length) {
			return;
		}
		var headerHeight = $('.site-header').outerHeight() || 60;
		var targetOffset = $el.offset().top - headerHeight - 20;
		$('html, body').animate({ scrollTop: targetOffset }, 800, 'swing');
	}

	function scrollToPanel(root, tabId) {
		scrollToEl(root.find('[data-franchise-panel="' + tabId + '"]'));
	}

	function sectionUrl(tabId) {
		var urls = cfg().sectionUrls || {};
		return urls[tabId] || '';
	}

	function redirectLegacyHash() {
		var hash = String(window.location.hash || '').replace(/^#/, '');
		var match = hash.match(/^franchise-panel-(.+)$/);
		if (!match) {
			return false;
		}
		var url = sectionUrl(match[1]);
		if (!url || match[1] === (cfg().currentSection || 'overview')) {
			return false;
		}
		window.location.replace(url);
		return true;
	}

	function activateTab(root, tabId, options) {
		options = options || {};

		// Multi-page sections: navigate when the target panel is not on this page.
		if (!root.find('[data-franchise-panel="' + tabId + '"]').length) {
			var url = sectionUrl(tabId);
			if (url) {
				var search = window.location.search || '';
				window.location.href = url + search + (tabId === 'locations' ? '#' + STATE_LIST_HASH : '');
			}
			return;
		}

		root.find('.franchise-tab').each(function () {
			var href = String($(this).attr('href') || '');
			var target = sectionUrl(tabId);
			var isActive = target
				? href.replace(/\/$/, '') === String(target).replace(/\/$/, '')
				: $(this).data('franchise-tab') === tabId;
			$(this).toggleClass('is-active', isActive);
			if (isActive) {
				$(this).attr('aria-current', 'page');
			} else {
				$(this).removeAttr('aria-current');
			}
		});

		root.find('[data-franchise-panel]').each(function () {
			var match = $(this).data('franchise-panel') === tabId;
			$(this).toggleClass('is-active', match);
			if (match) {
				$(this).removeAttr('hidden');
			} else {
				$(this).attr('hidden', 'hidden');
			}
		});

		refreshVisibleMaps(root);

		if (options.scroll) {
			scrollToPanel(root, tabId);
		}
	}

	function filterLocations(panel) {
		var search = String(panel.find('[data-filter-search]').val() || '').toLowerCase().trim();
		var state = String(panel.find('[data-filter-state]').val() || '').toUpperCase();
		var model = String(panel.find('[data-filter-model]').val() || '');
		var status = String(panel.find('[data-filter-status]').val() || '');
		var visible = 0;

		panel.find('[data-location-row]').each(function () {
			var $row = $(this);
			var ok = true;
			if (search) {
				var hay = ($row.data('name') || '') + ' ' + ($row.data('city') || '');
				ok = hay.indexOf(search) !== -1;
			}
			if (ok && state && String($row.data('state') || '').toUpperCase() !== state) {
				ok = false;
			}
			if (ok && model && String($row.data('model') || '') !== model) {
				ok = false;
			}
			if (ok && status && String($row.data('status') || '') !== status) {
				ok = false;
			}
			$row.toggle(ok);
			if (ok) {
				visible += 1;
			}
		});

		panel.find('[data-locations-empty]').prop('hidden', visible !== 0);

		var mapEl = panel.find('[data-franchise-map]').get(0);
		if (mapEl && window.DFDLocationsMap) {
			if (!mapEl._allLocations) {
				mapEl._allLocations = window.DFDLocationsMap.parseLocations(mapEl);
			}
			var filtered = mapEl._allLocations.filter(function (loc) {
				if (state && String(loc.state || '').toUpperCase() !== state) {
					return false;
				}
				if (model && String(loc.model || '') !== model) {
					return false;
				}
				if (status && String(loc.status || '') !== status) {
					return false;
				}
				if (search) {
					var hay = String(loc.title || '').toLowerCase() + ' ' + String(loc.city || '').toLowerCase();
					if (hay.indexOf(search) === -1) {
						return false;
					}
				}
				return true;
			});
			window.DFDLocationsMap.setLocations(mapEl, filtered);
		}
	}

	function placeLine(loc) {
		var city = loc.city || '';
		var state = loc.state || '';
		var zip = loc.zip || '';
		var line = city + (city && state ? ', ' : '') + state;
		if (zip) {
			line = line ? line + ' ' + zip : zip;
		}
		return line;
	}

	function renderStateLocationItems(items, highlightId) {
		var html = '';
		(items || []).forEach(function (loc) {
			var meta = [];
			var place = placeLine(loc);
			var isHighlight = highlightId && String(loc.id) === String(highlightId);
			if (place) {
				meta.push(escapeHtml(place));
			}
			if (loc.model_label) {
				meta.push(escapeHtml(loc.model_label));
			}
			if (loc.status_label) {
				meta.push(escapeHtml(loc.status_label));
			}
			if (loc.opened) {
				meta.push(escapeHtml(loc.opened));
			}

			html += '<li class="franchise-state-location' + (isHighlight ? ' is-highlighted' : '') +
				'" data-location-id="' + escapeHtml(loc.id) + '">';
			html += '<div class="franchise-state-location-copy">';
			html += '<strong class="franchise-state-location-title">' + escapeHtml(loc.title) + '</strong>';
			if (meta.length) {
				html += '<span class="franchise-state-location-meta">' + meta.join(' · ') + '</span>';
			}
			html += '</div>';
			if (typeof loc.lat === 'number' && typeof loc.lng === 'number') {
				html += '<button type="button" class="franchise-text-link" data-focus-location="' +
					escapeHtml(loc.id) + '">' +
					escapeHtml(i18n('showOnMap', 'Show on map')) + '</button>';
			}
			html += '</li>';
		});
		return html;
	}

	function setStateListStatus($wrap, text, isError) {
		var $status = $wrap.find('[data-state-locations-status]');
		if (!$status.length) {
			return;
		}
		if (text) {
			$status.text(text).prop('hidden', false).toggleClass('is-error', !!isError);
		} else {
			$status.text('').prop('hidden', true).removeClass('is-error');
		}
	}

	function updateStateBarActive($card, state) {
		$card.find('[data-open-state]').each(function () {
			var match = String($(this).data('open-state') || '').toUpperCase() === String(state || '').toUpperCase();
			$(this).toggleClass('is-active', match);
			$(this).attr('aria-current', match ? 'true' : null);
		});
	}

	function closeStateLocations(root) {
		var $card = root.find('[data-locations-by-state]');
		var $wrap = $card.find('[data-state-locations]');
		$wrap.attr('hidden', 'hidden')
			.removeData('state')
			.removeData('page')
			.removeData('total')
			.removeData('loading');
		$wrap.find('[data-state-locations-list]').empty();
		$wrap.find('[data-state-locations-more]').prop('hidden', true);
		$wrap.find('[data-state-locations-title]').text('');
		setStateListStatus($wrap, '');
		updateStateBarActive($card, '');
	}

	function fetchStateLocations(franchiseId, state, page, locationId) {
		var settings = cfg();
		return $.ajax({
			url: settings.ajaxUrl || '/wp-admin/admin-ajax.php',
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'dfd_franchise_state_locations',
				nonce: settings.nonce || '',
				franchise_id: franchiseId,
				state: state,
				page: page,
				location_id: locationId || 0
			}
		});
	}

	function openStateLocations(root, state, options) {
		options = options || {};
		state = String(state || '').toUpperCase();
		if (!state) {
			return;
		}

		var $panel = root.find('[data-franchise-panel="locations"]');
		var $card = $panel.find('[data-locations-by-state]');
		var $wrap = $card.find('[data-state-locations]');
		var $list = $wrap.find('[data-state-locations-list]');
		var $more = $wrap.find('[data-state-locations-more]');
		var $title = $wrap.find('[data-state-locations-title]');
		var franchiseId = parseInt(root.data('franchise-id'), 10) || 0;
		var page = options.append ? (parseInt($wrap.data('page'), 10) || 1) + 1 : 1;
		var highlightId = options.locationId || 0;

		if (!$wrap.length || !franchiseId) {
			return;
		}

		if ($wrap.data('loading')) {
			return;
		}

		activateTab(root, 'locations', { scroll: false });

		var $select = $panel.find('[data-filter-state]');
		if ($select.length) {
			var match = $select.find('option').filter(function () {
				return String($(this).val()).toUpperCase() === state;
			}).first().val();
			if (match) {
				$select.val(match);
			}
		}
		filterLocations($panel);

		updateStateBarActive($card, state);
		$wrap.removeAttr('hidden');

		if (!options.append) {
			$list.empty();
			$more.prop('hidden', true);
			$title.text(
				i18n('listHeading', 'Locations in %s').replace('%s', state)
			);
			setStateListStatus($wrap, i18n('loading', 'Loading locations…'), false);
		} else {
			$more.prop('disabled', true).text(i18n('loading', 'Loading locations…'));
		}

		$wrap.data('loading', true);
		$wrap.data('state', state);

		fetchStateLocations(franchiseId, state, page, options.append ? 0 : highlightId)
			.done(function (res) {
				if (!res || !res.success || !res.data) {
					setStateListStatus($wrap, i18n('error', 'Could not load locations. Please try again.'), true);
					return;
				}

				var data = res.data;
				var stateName = data.state_name || data.state || state;
				$title.text(
					i18n('listHeading', 'Locations in %s').replace('%s', stateName)
				);

				if (!options.append) {
					$list.html(renderStateLocationItems(data.items, highlightId));
				} else {
					$list.append(renderStateLocationItems(data.items, highlightId));
				}

				$wrap.data('page', data.page || page);
				$wrap.data('total', data.total || 0);

				var shown = $list.children().length;
				var total = data.total || 0;

				if (!total) {
					setStateListStatus($wrap, i18n('empty', 'No locations found in this state.'), false);
				} else {
					setStateListStatus(
						$wrap,
						i18n('showingOf', 'Showing %1$s of %2$s locations')
							.replace('%1$s', String(shown))
							.replace('%2$s', String(total)),
						false
					);
				}

				if (data.has_more) {
					$more.prop('hidden', false).prop('disabled', false)
						.text(i18n('showMore', 'Show more'));
				} else {
					$more.prop('hidden', true);
				}

				if (options.scroll !== false) {
					var $hi = highlightId
						? $list.find('[data-location-id="' + highlightId + '"]')
						: $();
					if ($hi.length) {
						$hi.addClass('is-highlighted');
						scrollToEl($hi);
					} else {
						scrollToEl($card);
					}
				} else if (highlightId) {
					$list.find('[data-location-id="' + highlightId + '"]').addClass('is-highlighted');
				}
			})
			.fail(function () {
				setStateListStatus($wrap, i18n('error', 'Could not load locations. Please try again.'), true);
				$more.prop('disabled', false).text(i18n('showMore', 'Show more'));
			})
			.always(function () {
				$wrap.removeData('loading');
			});
	}

	function parseFranchiseStateLink(href) {
		if (!href) {
			return null;
		}
		var a = document.createElement('a');
		a.href = href;
		if (a.hostname && a.hostname !== window.location.hostname) {
			return null;
		}
		if (a.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) {
			return null;
		}
		var params = new URLSearchParams(a.search || '');
		var state = String(params.get('state') || '').toUpperCase();
		if (!state) {
			return null;
		}
		return {
			state: state,
			locationId: locationIdFromParams(params),
			hash: String(a.hash || '').replace(/^#/, '')
		};
	}

	function locationIdFromParams(params) {
		return parseInt(params.get('unit') || params.get('location'), 10) || 0;
	}

	function applyUrlLocationState(root) {
		var params = new URLSearchParams(window.location.search);
		var hash = String(window.location.hash || '').replace(/^#/, '');
		var state = String(params.get('state') || '').toUpperCase();
		var locationId = locationIdFromParams(params);
		var goByState = hash === STATE_LIST_HASH;
		var goLocations = goByState ||
			hash === 'locations' ||
			hash === 'franchise-panel-locations' ||
			!!state;

		if (state) {
			var $select = root.find('[data-filter-state]');
			var match = $select.find('option').filter(function () {
				return String($(this).val()).toUpperCase() === state;
			}).first().val();
			if (match) {
				$select.val(match);
			}
		}

		if (goLocations) {
			activateTab(root, 'locations', { scroll: !!hash && !goByState && !state });
		}

		var $panel = root.find('[data-franchise-panel="locations"]');
		if ($panel.length && (state || goLocations)) {
			filterLocations($panel);
		}

		if (state && (goByState || locationId || hash === 'locations' || hash === 'franchise-panel-locations' || !hash)) {
			openStateLocations(root, state, {
				locationId: locationId,
				scroll: true
			});
		} else if (goByState) {
			scrollToEl(root.find('[data-locations-by-state]'));
		}
	}

	$(function () {
		var $root = $('.franchise-single');
		if (!$root.length || !window.DFDLocationsMap) {
			return;
		}

		if (redirectLegacyHash()) {
			return;
		}

		// Init hero maps immediately (always visible).
		$root.find('.franchise-hero-map, .franchise-map-sm').each(function () {
			if (!$(this).closest('[hidden]').length) {
				window.DFDLocationsMap.initMap(this);
			}
		});

		$root.on('click', '[data-locations-view]', function () {
			var view = $(this).data('locations-view');
			var $panel = $(this).closest('[data-franchise-panel="locations"]');
			$panel.find('[data-locations-view]').removeClass('is-active');
			$(this).addClass('is-active');
			$panel.find('[data-locations-pane]').each(function () {
				var match = $(this).data('locations-pane') === view;
				if (match) {
					$(this).removeAttr('hidden');
				} else {
					$(this).attr('hidden', 'hidden');
				}
			});
			refreshVisibleMaps($root);
		});

		$root.on('input change', '[data-locations-filters] input, [data-locations-filters] select', function () {
			filterLocations($(this).closest('[data-franchise-panel="locations"]'));
		});

		$root.on('click', '[data-open-state]', function (e) {
			e.preventDefault();
			openStateLocations($root, $(this).data('open-state'), { scroll: true });
		});

		$root.on('click', '[data-state-locations-more]', function (e) {
			e.preventDefault();
			var $wrap = $(this).closest('[data-state-locations]');
			var state = $wrap.data('state');
			if (state) {
				openStateLocations($root, state, { append: true, scroll: false });
			}
		});

		$root.on('click', '[data-state-locations-close]', function (e) {
			e.preventDefault();
			closeStateLocations($root);
		});

		$root.on('click', '[data-state-locations] [data-focus-location]', function (e) {
			e.preventDefault();
			var locationId = $(this).attr('data-focus-location');
			var $panel = $root.find('[data-franchise-panel="locations"]');
			var mapEl = $panel.find('[data-franchise-map]').get(0);
			if (mapEl && window.DFDLocationsMap) {
				window.DFDLocationsMap.focusLocation(mapEl, locationId);
				scrollToEl($panel.find('[data-locations-pane="map"]'));
			}
		});

		// Same-page "View details" from map popups: open state list instead of reloading.
		$root.on('click', '.franchise-map-popup-link, .franchise-map-popup-title', function (e) {
			var parsed = parseFranchiseStateLink($(this).attr('href'));
			if (!parsed) {
				return;
			}
			e.preventDefault();
			openStateLocations($root, parsed.state, {
				locationId: parsed.locationId,
				scroll: true
			});
			if (window.history && window.history.replaceState) {
				var url = window.location.pathname +
					'?state=' + encodeURIComponent(parsed.state) +
					(parsed.locationId ? '&unit=' + encodeURIComponent(parsed.locationId) : '') +
					'#' + STATE_LIST_HASH;
				window.history.replaceState(null, '', url);
			}
		});

		applyUrlLocationState($root);
	});
})(jQuery);
